export enum DashboardState {
  design = 1, /// // design aşaması
  locked = 5, /// // Şu an bu ekranda başka biri çalışıyor!
  readOnly = 6, /// /// Ekranı görme yetkim yok.
  dataDiagramScheme = 9, /// //// Diagram Scheme
  workFlow = 11, /// ///// workflow
  configManager = 12, /// ///// App settings,
  notificationTemplate = 13, /// ///// Notification Template,
  scheduledJobs = 14, /// ///// Scheduled Jobs,
  apiManagement = 15, /// ///// Api Management,
  zendesk = 16, /// //// Zendesk
  reportDesigner = 17, /// ///// Report Designer,
  runSettings = 18, /// ///// Report Designer,
  codeGeneration = 19, /// ///// Report Designer,
  branching = 20, /// ///// Branching
  aiHub = 21, /// ///// AI Hub
  documentParameters = 22 /// ///// DMS Document Parameters (KOA-17254)
}
